import { AppColors } from './AppColors';

export const SIGN_UP_FLOW = false;

export const DASHBOARD_VIEWS = {
	ORGANIZATIONAL: { CODE: 'ORGANIZATIONAL', LABEL: 'Organizational', COLOR: '#3a39f6' },
	DEPARTMENTAL: { CODE: 'DEPARTMENTAL', LABEL: 'Departmental', COLOR: '#3a39f6' },
	HIERARCHICAL: { CODE: 'HIERARCHICAL', LABEL: 'Hierarchical', COLOR: '#3a39f6' },
	GENDER: { CODE: 'GENDER', LABEL: 'Gender', COLOR: '#7F56D9' },
	LOCATION: { CODE: 'LOCATION', LABEL: 'Location', COLOR: '#7F56D9' },
};

// ask sir better approach StaticcardsColor on DashBaord
export const staticCardColor = {
	RED: { CODE: 'RED', LABEL: 'Red', COLOR: '#f44336' }, // Muted red
	YELLOW: { CODE: 'YELLOW', LABEL: 'Yellow', COLOR: '#ffc107' }, // Golden yellow
	GREEN: { CODE: 'GREEN', LABEL: 'Green', COLOR: '#4caf50' } // Balanced green
}

export const DEPARTMENTS = [
	{ name: 'Design', code: 'DESIGN' },
	{ name: 'Product', code: 'PRODUCT' },
	{ name: 'Marketing', code: 'MARKETING' },
	{ name: 'Software Engineering', code: 'SOFTWARE' },
	{ name: 'Finance', code: 'FINANCE' },
	{ name: 'Operations', code: 'OPERATIONS' },
	{ name: 'Customer Success', code: 'CUSTOMER_SUCCESS' },
];

export const GENDERS = [
	{ name: 'Male', code: 'male', color: 'purple' },
	{ name: 'Female', code: 'female', color: 'orange' },
	{ name: 'Others', code: 'other', color: 'blue' },
];

export const CAMPAIGN_STATUS = {
	live: { code: 'live', color: AppColors.LABEL_YELLOW , bgColor : AppColors.BAGROUND_YELLOW , border : AppColors.BORDER_YELLOW}, 
	stopped: { code: 'stopped',color: AppColors.LABEL_RED , bgColor : AppColors.BAGROUND_RED , border : AppColors.BORDER_RED },
	completed: { code: 'completed', color: AppColors.LABEL_SUCCESS , bgColor : AppColors.BAGROUND_SUCCESS , border : AppColors.BORDER_SUCCESS},
	draft: { code: 'draft', color: AppColors.LABEL_LIGHT , bgColor : AppColors.BAGROUND_LIGHT , border : AppColors.BORDER_LIGHT},
    archived: { code: 'archived',  color: '#607D8B',  bgColor: '#ECEFF1', border: '#90A4AE' },
};

export const USER_TYPE = {
	ANONYMOUS: 'anonymous',
};


// Sample data for dropdowns
export const FILTER_OPTIONS = [
	{ label: 'Date Of Joining', value: 'dateOfJoining' },
	{ label: 'Department', value: 'department' },
	{ label: 'Timezone', value: 'timezone' },
	{ label: 'Source', value: 'source' },
	{ label: 'Date Of Relieving', value: 'dateOfRelieving' }
];

export const FILTER_OPTIONS_key_map = {
	dateOfJoining: 'Date Of Joining',
	department: 'Department',
	timezone: 'Timezone',
	source: 'Source',
	dateOfRelieving: 'Date Of Relieving'
};

export const DATE_CONDITIONS = [
	{ label: 'Before', value: 'before' },
	{ label: 'After', value: 'after' },
];

export const DATE_CONDITIONS_key_map = {
	before: 'Before',
	after: 'After',
};


export const SOURCES = [
	{ label: 'Automatic', value: 'automatic' },
	{ label: 'Manual', value: 'manual' },
];

export const SOURCES_key_map = {
	automatic: 'Automatic',
	manual: 'Manual',
};